var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivacyPolicy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3748 19.997V9.53882C33.3749 9.40675 33.3489 9.27597 33.2984 9.15396C33.2479 9.03194 33.1738 8.9211 33.0803 8.82777L27.8136 3.56106C27.6255 3.37275 27.3704 3.26684 27.1042 3.2666H7.61002C7.34379 3.2666 7.08847 3.37236 6.90021 3.56061C6.71196 3.74887 6.6062 4.00419 6.6062 4.27042V35.7235C6.6062 35.9897 6.71196 36.2451 6.90021 36.4333C7.08847 36.6216 7.34379 36.7273 7.61002 36.7273H21.6635M13.2983 16.6509H26.6826M13.2983 9.95875H19.9905M13.2983 23.343H18.3175",
    stroke: "#333333",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6827 3.2666V8.95493C26.6827 9.22116 26.7885 9.47648 26.9768 9.66474C27.165 9.85299 27.4203 9.95875 27.6866 9.95875H33.3749M33.3615 25.2252L37.6378 26.311C38.0828 26.4248 38.3957 26.8297 38.3823 27.2881C38.0945 36.9214 32.5384 38.4004 32.5384 38.4004C32.5384 38.4004 26.9822 36.9214 26.6945 27.2881C26.6899 27.065 26.761 26.847 26.8962 26.6696C27.0314 26.4922 27.2227 26.3658 27.439 26.311L31.7152 25.2252C32.2556 25.088 32.8211 25.088 33.3615 25.2252Z",
    stroke: "#333333",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicy);
export default __webpack_public_path__ + "static/media/PrivacyPolicy.4330b3a1c5d24fb16d9e474f516abd6b.svg";
export { ForwardRef as ReactComponent };